/* Global Menu V3 — progressive, accessible Dr Sknn navigation. */
(function () {
  "use strict";

  function init(details) {
    if (!details || details.dataset.drsknnMenuV2Ready === "true") return;
    details.dataset.drsknnMenuV2Ready = "true";

    var menu = details.querySelector(".drsknn-menu-v2");
    var panel = details.querySelector(".drsknn-menu-v2__panel");
    var header = details.querySelector(".drsknn-menu-v2__header");
    var brandTitle = details.querySelector(".drsknn-menu-v2__brand h2");
    var back = details.querySelector("[data-drsknn-menu-v2-back]");
    var views = Array.prototype.slice.call(details.querySelectorAll("[data-drsknn-menu-v2-view]"));
    var summary = details.querySelector("summary");
    var viewport = details.querySelector(".drsknn-menu-v2__viewport");
    var scrollCue = details.querySelector("[data-drsknn-menu-v2-scroll-cue]");
    var originVideo = details.querySelector("[data-drsknn-menu-v2-origin-video]");
    var returnFocus = null;
    var activeView = "main";
    var originVideoLoaded = false;
    var originVideoAttempts = 0;
    var originDataLoading = false;
    if (!menu || !panel || !header || !back || !summary || !viewport || !views.length) return;

    function updateScrollCue() {
      if (!scrollCue) return;
      var mobile = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
      var hasMore = viewport.scrollHeight > viewport.clientHeight + 12;
      var atStart = viewport.scrollTop < 24;
      scrollCue.classList.toggle("is-visible", Boolean(details.open && mobile && hasMore && atStart));
    }

    function updateTop() {
      var wrapper = document.querySelector(".header-wrapper");
      var top = window.innerWidth <= 749 ? 0 : Math.max(0, wrapper ? wrapper.getBoundingClientRect().bottom : 0);
      menu.style.setProperty("--menu-top", Math.round(top) + "px");
    }

    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
        return !node.hidden && node.offsetParent !== null;
      });
    }

    function setView(name, shouldFocus, returning) {
      var next = views.find(function (view) { return view.getAttribute("data-drsknn-menu-v2-view") === name; });
      if (!next) return;
      var viewNames = { treatments: "Treatments", conditions: "Conditions", mens: "Men’s concerns", skincare: "Skincare" };
      panel.classList.toggle("is-returning", returning === true);
      activeView = name;
      views.forEach(function (view) {
        var active = view === next;
        view.hidden = !active;
        view.classList.toggle("is-active", active);
      });
      var isMain = name === "main";
      back.hidden = isMain;
      header.classList.toggle("has-subview", !isMain);
      brandTitle.textContent = isMain ? "How can we help?" : (viewNames[name] || "Explore Dr Sknn");
      viewport.scrollTop = 0;
      window.requestAnimationFrame(updateScrollCue);
      window.setTimeout(function () { panel.classList.remove("is-returning"); }, 320);
      if (shouldFocus) (isMain ? brandTitle : back).focus({ preventScroll: true });
    }

    function prefersStillVideo() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      return Boolean(
        (connection && connection.saveData) ||
        (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      );
    }

    function findOriginDayTwo() {
      var data = window.DR_SKNN_ORIGIN_VIDEO_DATA || {};
      var journeys = Array.isArray(data.journeys) ? data.journeys : [];
      var journey = journeys.find(function (item) { return item && item.key === "origin-two-hour-video-journey"; });
      if (!journey || !Array.isArray(journey.items)) return null;
      return journey.items.find(function (item) {
        var label = String((item && (item.timeframe || item.caption)) || "").toLowerCase();
        return label.indexOf("day 2") !== -1;
      }) || null;
    }

    function playOriginVideo() {
      if (!originVideo || prefersStillVideo()) return;
      var item = findOriginDayTwo();
      if (!item) {
        if (!originDataLoading) {
          var source = originVideo.getAttribute("data-origin-data-src");
          var existingDataScript = document.querySelector('script[data-drsknn-menu-v2-origin-data], script[src*="drsknn-origin-video-v2-data"]');
          if (source && !existingDataScript) {
            var dataScript = document.createElement("script");
            dataScript.src = source;
            dataScript.defer = true;
            dataScript.setAttribute("data-drsknn-menu-v2-origin-data", "");
            dataScript.addEventListener("load", playOriginVideo, { once: true });
            dataScript.addEventListener("error", function () { originDataLoading = false; }, { once: true });
            document.head.appendChild(dataScript);
          } else if (existingDataScript) {
            existingDataScript.addEventListener("load", playOriginVideo, { once: true });
          }
          originDataLoading = true;
        }
        originVideoAttempts += 1;
        if (details.open && originVideoAttempts < 20) window.setTimeout(playOriginVideo, 150);
        return;
      }
      if (!originVideoLoaded) {
        originVideo.muted = true;
        originVideo.defaultMuted = true;
        originVideo.src = item.videoSrc || item.src;
        if (item.poster) originVideo.poster = item.poster;
        originVideo.load();
        originVideoLoaded = true;
      }
      var playback = originVideo.play();
      if (playback && typeof playback.catch === "function") playback.catch(function () {});
    }

    function closeMenu(restore) {
      summary.setAttribute("aria-expanded", "false");
      if (details.open) details.removeAttribute("open");
      document.documentElement.classList.remove("drsknn-menu-v2-open");
      document.body.classList.remove("drsknn-menu-v2-open", "overflow-hidden-tablet");
      setView("main", false, true);
      if (originVideo) originVideo.pause();
      if (scrollCue) scrollCue.classList.remove("is-visible");
      if (restore !== false && returnFocus && typeof returnFocus.focus === "function") returnFocus.focus({ preventScroll: true });
    }

    function openMenu() {
      returnFocus = document.activeElement;
      summary.setAttribute("aria-expanded", "true");
      updateTop();
      document.documentElement.classList.add("drsknn-menu-v2-open");
      document.body.classList.add("drsknn-menu-v2-open", "overflow-hidden-tablet");
      originVideoAttempts = 0;
      playOriginVideo();
      window.requestAnimationFrame(function () {
        var close = details.querySelector("[data-drsknn-menu-v2-close].drsknn-menu-v2__close");
        if (close) close.focus({ preventScroll: true });
        updateScrollCue();
      });
    }

    function closeThen(action) {
      closeMenu(false);
      window.requestAnimationFrame(action);
    }

    details.addEventListener("toggle", function () {
      if (details.open) openMenu();
      else {
        summary.setAttribute("aria-expanded", "false");
        document.documentElement.classList.remove("drsknn-menu-v2-open");
        document.body.classList.remove("drsknn-menu-v2-open", "overflow-hidden-tablet");
        if (scrollCue) scrollCue.classList.remove("is-visible");
      }
    });

    details.addEventListener("click", function (event) {
      var target = event.target.closest("[data-drsknn-menu-v2-close], [data-drsknn-menu-v2-open], [data-drsknn-menu-v2-back], [data-drsknn-menu-v2-start], [data-drsknn-v5-consultation], [data-drsknn-menu-v2-treatment], [data-drsknn-menu-v2-origin], [data-drsknn-menu-v2-destination]");
      if (!target) return;
      if (target.hasAttribute("data-drsknn-menu-v2-close")) { event.preventDefault(); closeMenu(true); return; }
      if (target.hasAttribute("data-drsknn-menu-v2-open")) { event.preventDefault(); setView(target.getAttribute("data-drsknn-menu-v2-open"), true, false); return; }
      if (target.hasAttribute("data-drsknn-menu-v2-back")) { event.preventDefault(); setView("main", true, true); return; }
      if (target.hasAttribute("data-drsknn-menu-v2-start")) {
        event.preventDefault();
        closeThen(function () {
          var start = document.querySelector('[data-drsknn-v5] [data-v5-open-flow="guided"]');
          if (start) start.click();
          else window.location.assign("/?open=guided");
        });
        return;
      }
      if (target.hasAttribute("data-drsknn-v5-consultation")) {
        event.preventDefault();
        closeThen(function () {
          if (typeof window.openDrSknnConsultation === "function") window.openDrSknnConsultation();
          else window.location.assign("/?open=consultation");
        });
        return;
      }
      if (target.hasAttribute("data-drsknn-menu-v2-treatment")) {
        event.preventDefault();
        closeThen(function () {
          if (typeof window.openDrSknnTreatmentFinder === "function") window.openDrSknnTreatmentFinder("/?open=treatment", summary);
          else window.location.assign("/?open=treatment");
        });
        return;
      }
      if (target.hasAttribute("data-drsknn-menu-v2-origin")) {
        event.preventDefault();
        closeThen(function () {
          function openOriginDestination() {
            var journey = document.querySelector("[data-origin-float-open]");
            if (journey) { journey.click(); return; }
            var proof = document.querySelector("#drsknn-home-v2-proof");
            if (!proof) {
              window.location.assign("/?open=proof&proof_category=origin-laser#drsknn-home-v2-proof");
              return;
            }
            proof.scrollIntoView({ behavior: "smooth", block: "start" });
            var attempts = 0;
            function activateOrigin() {
              var origin = document.querySelector('[data-dps-category="origin-laser"], [data-proof-v3-open-category="Origin Laser"], [data-proof-v3-open-category="origin-laser"]');
              if (origin) { origin.click(); return; }
              attempts += 1;
              if (attempts < 12) window.setTimeout(activateOrigin, 250);
            }
            window.setTimeout(activateOrigin, 350);
          }
          var performanceLoader = window.DrSknnHomepageV2Performance;
          if (performanceLoader && typeof performanceLoader.loadProof === "function") {
            performanceLoader.loadProof().then(openOriginDestination);
          } else {
            openOriginDestination();
          }
        });
        return;
      }
      if (target.hasAttribute("data-drsknn-menu-v2-destination")) closeMenu(false);
    });

    document.addEventListener("keydown", function (event) {
      if (!details.open) return;
      if (event.key === "Escape") { event.preventDefault(); closeMenu(true); return; }
      if (event.key !== "Tab") return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    viewport.addEventListener("scroll", updateScrollCue, { passive: true });
    window.addEventListener("resize", function () { if (details.open) { updateTop(); updateScrollCue(); } }, { passive: true });
    if (originVideo) {
      originVideo.addEventListener("canplay", function () { originVideo.classList.add("is-ready"); }, { once: true });
      originVideo.addEventListener("error", function () { originVideo.classList.remove("is-ready"); });
    }
    summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    setView(activeView, false);
  }

  function boot() {
    document.querySelectorAll("[data-drsknn-menu-v2]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
})();
